type ParamsObj = Record<any, any>;

export enum Resource {
  SOFT_CREDIT_PULL_REPORT = '/softcreditpull/:dealId/credit-report',
}

export type ApiCacheKey<P extends ParamsObj> = {
  resource: Resource;
  params: P;
};

export const getKey = <P extends ParamsObj>(
  resource: Resource,
  params: P,
): ApiCacheKey<P> => ({
  resource,
  params,
});
